import styled from 'styled-components';

export const Stats = styled('div')`
  margin: 0;
  margin-bottom: 2px;
  margin-top: 24px;
  ${(props) => props.theme.typography.largeStrong}
`;

export const Label = styled('span')`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.7)};
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
`;

export const TipContainer = styled('span')`
  display: block;
  max-width: 210px;
`;
